export default __webpack_public_path__ + "b039b2d83982c8256af34260e546303b.png";